<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">问题详情</li>
      </ul>
      <a href="javascript:history.go(-1);" class="go-back">
        <div><Icon type="ios-arrow-dropleft" size="20" />返回</div>
      </a>
    </div>

    <div class="member-main-body">
      <div class="main-header">
        <span v-if="exerId > 0">题目ID：{{ exerId }}</span>
        <span v-else>视频ID：{{ pptId }}</span>
        <span style="margin-left: 20px">问题ID：{{ qId }}</span>
        <div style="float:right" v-if="loginUser.agencyId === 0">
          <Button type="primary" @click="handleAiRepository"
            >加入AI答题库</Button
          >
        </div>
      </div>

      <div class="practice-item">
        <practice-item
          v-if="exerId > 0"
          ref="practiceItem"
          :data="exerInfo"
          :index="1"
          v-model="exerInfo.userKey"
          practiceType="discuss"
        ></practice-item>
        <video-player
          v-else-if="pptId > 0"
          :width="910"
          :height="500"
        ></video-player>
      </div>

      <div class="question-list">
        <div class="question-info clearfix">
          <div class="question-info-img">
            <Avatar
              :src="concatImageUrl(questionInfo.qUserPic, 50, 50, true)"
              size="50"
            />
          </div>
          <div class="question-info-user">
            <h4>
              <span>{{ questionInfo.qUserName }}</span>
              <span v-if="questionInfo.teacherType == 3" class="guide"></span>
              <div v-if="questionInfo.teacherType == 3" >
              <img src="../../assets/images/Transferred.png" alt="">
            </div>
            </h4>
            <p class="question-info-position">
              发自：{{ questionInfo.fromPosition }}
            </p>
          </div>
          <!-- <span class="question-info-time">{{ questionInfo.qTime }}</span> -->
        </div>
        <div class="question-content">
          <div class="question-title" v-latex="questionInfo.qContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></div>
          <ul class="question-image clearfix" id="qimages">
            <li v-if="questionInfo.qPic1">
              <img
              alt="question"
                :src="concatImageUrl(questionInfo.qPic1, 0, 0, true)"
              />
            </li>
            <li v-if="questionInfo.qPic2">
              <img
              alt="question"
                :src="concatImageUrl(questionInfo.qPic2, 0, 0, true)"
              />
            </li>
            <li v-if="questionInfo.qPic3">
              <img
                alt="question"
                :src="concatImageUrl(questionInfo.qPic3, 0, 0, true)"
              />
            </li>
          </ul>
        </div>
        <div class="question-action clearfix">
          <div class="fl">
            <span style="color: #999;font-size: 14px; margin-right: 10px;">{{ questionInfo.qTime }}</span>
            <a href="javascript:;" style="color: #666" title="回复数">
              <img
                src="../../assets/images/icon-comment.png"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  margin-right: 5px;
                "
              />
              <span style="display: inline-block; vertical-align: middle"
              >回复数 {{ questionInfo.commentCount }}</span
              >
            </a>
            <a href="javascript:;" style="margin-left: 2rem" @click="saveGoods">
              <img
                src="../../assets/images/icon-good.png"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  margin-right: 5px;
                  "
              />
              <span style="display: inline-block; vertical-align: middle">{{
                questionInfo.goodNum
              }}</span>
            </a>
          </div>
          <div class="fr">
          </div>
        </div>
        <div class="question-ask" v-if="answerVisible()">
          <div class="ask-text">
            <textarea
              v-model="answerInfo.commentContent"
              maxlength="6000"
              placeholder="回答问题"
            ></textarea>
          </div>
          <div class="ask-action clearfix">
            <Upload
              :action="uploaderUrl"
              :headers="uploaderHeaer"
              :data="uploaderData"
              :max-size="2048"
              :before-upload="handleBefore"
              :on-success="handleSuccess"
              :show-upload-list="false"
              class="fl"
            >
              <Icon type="md-images" />
            </Upload>
            <div class="fr">
              <Button
                v-if="questionInfo.isReport == 0"
                type="success"
                size="small"
                shape="circle"
                @click="markIsReport"
                >标记为待详解</Button
              >
              <Button
                v-else
                type="success"
                size="small"
                shape="circle"
                @click="markIsReport"
                >取消待详解</Button
              >
              <Button
                type="primary"
                size="small"
                shape="circle"
                style="margin-left: 2rem"
                @click="saveAnswer"
                >确认回答</Button
              >
            </div>
          </div>
          <div class="ask-image clearfix">
            <span v-for="(item, index) in picFileList" :key="index">
              <a href="javascript:;" title="删除图片" @click="handleRemove"
                >×</a
              >
              <i></i>
              <img :src="concatImageUrl(item, 73, 73, true)" />
            </span>
          </div>
        </div>

        <div
          class="question-answer"
          v-for="(common, i) in questionInfo.comments.filter((m) => m.pId == 0)"
          :key="i"
        >
          <div class="question-answer-content clearfix teacher-box">
            <Avatar
              :src="concatImageUrl(common.userPic, 30, 30, true)"
              class="question-answer-avatar"
              size="30"
            />
            <p>
              <span class="question-answer-name">{{ common.userName }}</span>
              <!-- 是教师时才显示 -->
              <Tag color="warning" v-show="common.isCommentByTeach">教师</Tag>
              <span class="question-answer-show" v-latex="common.commentContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></span>
            </p>
            <p style="margin-left: 46px;">
              <span class="time">{{ common.commentTime }}</span>
              <a
                href="javascript:;"
                title="点击回复"
                class="replay-action"
                @click="replyVisible(common)"
              >
                <Icon custom="ich-icon ich-icon-comment" size="16" />回复
              </a>
              <span v-if="loginUser.ugid !== 5 && questionInfo.teacherType == 2 && common.teacherType==2 && common.article1" class="artificial" @click="changeArtificial(questionInfo)">
                <img src="../../assets/images/artificial.png" alt="">
                <span>转人工</span>
              </span>
            </p>
          </div>
          <!-- 教师回答展示图片 -->
          <ul
            class="question-answer-image clearfix"
            v-show="common.isCommentByTeach && common.commentPic1"
          >
            <li v-show="common.commentPic1">
              <a
                :href="concatImageUrl(common.commentPic1, 0, 0, true)"
                target="_blank"
              >
                <img
                  alt="answer"
                  :src="concatImageUrl(common.commentPic1, 60, 60, true)"
                />
              </a>
            </li>
            <li v-show="common.commentPic2">
              <a
                :href="concatImageUrl(common.commentPic2, 0, 0, true)"
                target="_blank"
              >
                <img
                  alt="answer"
                  :src="concatImageUrl(common.commentPic2, 60, 60, true)"
                />
              </a>
            </li>
            <li v-show="common.commentPic3">
              <a
                :href="concatImageUrl(common.commentPic3, 0, 0, true)"
                target="_blank"
              >
                <img
                  alt="answer"
                  :src="concatImageUrl(common.commentPic3, 60, 60, true)"
                />
              </a>
            </li>
          </ul>
          <div
            class="comment-reply am-margin-top-sm"
            v-show="common.replyVisible"
          >
            <input
              name="reply-content"
              v-model="common.replyContent"
              maxlength="200"
              :placeholder="'回复' + common.userName"
            />
            <button type="button" @click="saveUserReply(common)">回复</button>
          </div>
          <!-- 回复列表 -->
          <div
            class="question-answer-reply"
            v-if="
              questionInfo.comments.filter((m) => m.pId == common.commentId)
                .length > 0
            "
          >
            <div
              class="question-answer-content"
              v-for="(reply, ri) in questionInfo.comments.filter(
                (m) => m.pId == common.commentId
              )"
              :key="ri"
            >
              <Avatar
                :src="concatImageUrl(reply.userPic, 30, 30, true)"
                class="question-answer-avatar"
                size="30"
              />
              <p>
                <span class="color2">{{ reply.userName }}</span> 回复
                <span class="color2">{{ reply.pName }}</span>
                ： <span v-latex="reply.commentContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></span>
              </p>
              <p>
                <span class="time">{{ reply.commentTime }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="aiModelVisible"
      title="确定无误需要加入AI答疑库吗?"
      :closable="false"
      :mask-closable="false"
      width="560"
      class-name="vertical-center-modal"
      @on-ok="addAiRepository"
    >
      <div style="padding:12px 24px;">
        若该问题与该课程知识点无关的问题，请建议放入AI答疑库，下次学生提出无关知识点问题系统将自动回复（无需放入AI答疑库，请点击取消）
      </div>
      <Tooltip placement="right-start" max-width="360">
        <a style="color:#57a3f3; margin-left:24px;">鼠标移入查看示例</a>
        <div slot="content">
          <p>示例提问：主观题怎么手动评星？</p>
          <p>示例回答：同学您好！输入文字作答的主观题，系统暂无法识别作答是否正确，统一把答案判为“错误”，请忽略；您只需在答题后参考解析给自己的答案评星：
            3颗星含以下，是错误，4-5颗星是正确，谢谢！
          </p>
        </div>
      </Tooltip>
      <Form
        ref="aiForm"
        :model="aiForm"
        :rules="ruleAiForm"
        :label-width="80"
        style="padding:12px 24px"
      >
        <FormItem label="提问内容" prop="qValue">
          <Input
            v-model="aiForm.qValue"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            placeholder="请输入..."
          ></Input>
        </FormItem>
        <FormItem label="回答内容" prop="aValue">
          <Input
            v-model="aiForm.aValue"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            placeholder="请输入..."
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import PracticeItem from '../../components/exercise/PracticeItem';
import VideoPlayer from '../../components/common/VideoPlayer';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

import { siteMixin } from '../../utils/mixin';
import { user, study } from '../../request';
export default {
  mixins: [siteMixin],
  data() {
    return {
      qId: 0,
      exerInfo: {},
      questionInfo: {
        comments: [],
      },
      answerInfo: {
        userId: 0,
        commentId: 0,
        commentContent: '',
      },
      uploaderUrl: process.env.VUE_APP_API_URL + '/api/pc/upload',
      uploaderHeaer: {
        Authorization: 'Beego aHVhaGFuOmJlZWdvMjAxNQ==',
      },
      uploaderData: {
        dir: 'APPIMG',
      },
      picFileList: [],
      aiModelVisible: false,
      aiForm: {
        qValue: '',
        aValue: '',
      },
      ruleAiForm: {
        qValue: [
          {
            required: true,
            message: '请输入提问内容',
            trigger: 'blur',
          },
        ],
        aValue: [
          {
            required: true,
            message: '请输入回答内容',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted() {
    this.setMetaData('问题详情');
    if (!this.initParams()) return;
    if (this.exerId > 0) {
      this.getExercidseInfo();
    }
    if (this.pptId > 0) {
      this.setIsBuy(true);
      this.getVideoInfo();
    }
    this.getQuestionInfo();
  },
  methods: {
    initParams() {
      const qId = this.$route.query.qid;
      const exerId = this.$route.query.exerid;
      const pptId = this.$route.query.pptid;
      // if (qId && (exerId || pptId)) {
      if (qId) {
        this.qId = qId;
        if (exerId) {
          this.setPptId(0);
          this.setExerId(exerId);
        }
        if (pptId) {
          this.setExerId(0);
          this.setPptId(pptId);
        }
        return true;
      } else {
        this.$Message.error('参数错误');
        return false;
      }
    },
    setImagesReview() {
      const viewDom = document.getElementById('qimages');
      new Viewer(viewDom, {
        navbar: false,
        title: false,
        toolbar: {
          zoomIn: 'large',
          zoomOut: 'large',
          oneToOne: 'large',
          reset: 'large',
          prev: 'large',
          // play: {
          //   show: 1,
          //   size: "large",
          // },
          next: 'large',
          rotateLeft: 'large',
          rotateRight: 'large',
          // flipHorizontal: "large",
          // flipVertical: "large",
        },
      });
    },
    getQuestionInfo() {
      user
        .getQuestionInfo(
          this.loginUser.userId,
          this.qId,
          this.loginUser.ugid > 3 ? 1 : 0
        )
        .then((res) => {
          //console.log("questionInfo", res);
          if (res.status === 1) {
            this.questionInfo = res.data;
            let lastA1Index = null;
            this.questionInfo.comments.forEach((common) => {
              this.$set(common, 'replyVisible', false);
              this.$set(common, 'replyContent', '');
              // 转人工只有第一条
              if (!lastA1Index && common.isCommentByTeach ) {
                common.article1 = true
                lastA1Index = true;
              }
            });
            let answerList = this.questionInfo.comments.filter(
              (m) => m.isCommentByTeach
            );
            if (answerList.length > 0) {
              this.answerInfo = answerList[0];
              this.picFileList = [];
              if (this.answerInfo.commentPic1) {
                this.picFileList.push(this.answerInfo.commentPic1);
              }
              if (this.answerInfo.commentPic2) {
                this.picFileList.push(this.answerInfo.commentPic2);
              }
              if (this.answerInfo.commentPic3) {
                this.picFileList.push(this.answerInfo.commentPic3);
              }
            }
            this.$nextTick(() => {
              this.setImagesReview();
            });
          }
        });
    },
    getExercidseInfo() {
      study.getExerciseInfo(this.exerId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.exerInfo = res.data;
          this.$set(this.exerInfo, 'userKey', this.exerInfo.rightKey);
          this.$set(this.exerInfo, 'doResult', 1);
          this.$set(this.exerInfo, 'titleVisible', false);
          this.$set(this.exerInfo, 'analyzeVisible', false);
        }
      });
    },
    getVideoInfo() {
      user.getVideoInfo(this.pptId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.setVideoId(res.data.bVideoId);
        }
      });
    },
    answerVisible() {
      return this.loginUser.ugid > 3;
      // return (
      //   this.loginUser.ugid > 3 &&
      //   (this.answerInfo.userId == 0 ||
      //     this.answerInfo.userId == this.loginUser.userId)
      // );
    },
    markIsReport() {
      const reportResult = this.questionInfo.isReport == 1 ? 0 : 1;
      user.markQuestionIsReport(this.qId, reportResult).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          if (reportResult == 1) {
            this.$Message.success('标记为待详解成功');
          } else {
            this.$Message.success('取消待详解成功');
          }
          this.getQuestionInfo();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    saveGoods() {
      study.saveUserGoods(this.qId, this.loginUser.userId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.getQuestionInfo();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    saveAnswer() {
      //加入AI智能答疑库
      this.handleAiRepository();
      //初始化图片
      this.picFileName1 =
        this.picFileList.length >= 1 ? this.picFileList[0] : '';
      this.picFileName2 =
        this.picFileList.length >= 2 ? this.picFileList[1] : '';
      this.picFileName3 =
        this.picFileList.length >= 3 ? this.picFileList[2] : '';
      if (this.answerInfo.commentId == 0) {
        this.postAnswer();
      } else if (this.answerInfo.commentId > 0) {
        this.updateAnswer();
      }
    },
    postAnswer() {
      //初始化参数
      let data = {
        UserId: this.loginUser.userId,
        PName: '',
        PId: 0,
        UmcId: this.questionInfo.umcId,
        QId: this.questionInfo.qId,
        FromPosition: '教师回答问题',
        CommentContent: this.answerInfo.commentContent,
        IsCommentByTeach: true,
        CommentPic1: this.picFileName1,
        CommentPic2: this.picFileName2,
        CommentPic3: this.picFileName3,
      };
      study.saveUserComment(data).then((res) => {
        //console.log("saveComment", res);
        if (res.status === 1) {
          this.$Message.success('回答成功');
          this.getQuestionInfo();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    updateAnswer() {
      let data = {
        commentId: this.answerInfo.commentId,
        CommentContent: this.answerInfo.commentContent,
        CommentPic1: this.picFileName1,
        CommentPic2: this.picFileName2,
        CommentPic3: this.picFileName3,
      };
      study.modifyUserComment(data).then((res) => {
        if (res.status === 1) {
          this.$Message.success('回答成功');
          this.getQuestionInfo();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    replyVisible(item) {
      item.replyVisible = !item.replyVisible;
    },
    saveUserReply(item) {
      let data = {
        UserId: this.loginUser.userId,
        PName: item.userName,
        PId: item.commentId,
        UmcId: item.umcId,
        QId: item.qId,
        FromPosition: item.fromPosition,
        CommentContent: item.replyContent,
        IsCommentByTeach: false,
      };
      const { teacherType } = this.questionInfo;
      const hasA3 = this.questionInfo?.comments?.some(row =>
        row.teacherType === 1 || row.teacherType === 3 || row.teacherType === 4
      );
      if (teacherType == 1 || teacherType == 3 || teacherType == 4 || hasA3) {
        data.teacherType = 1;
      }
      study.saveUserComment(data).then((res) => {
        //console.log("saveComment", res);
        if (res.status === 1) {
          this.$Message.success('回复成功');
          this.getQuestionInfo();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleBefore(file) {
      if (this.picFileList.length >= 3) {
        this.$Message.error('最多上传3张图片');
        return false;
      }
    },
    handleRemove(index) {
      this.picFileList.splice(index, 1);
    },
    handleSuccess(res, file, fileList) {
      if (res.Status) {
        this.picFileList.push(res.Url);
      }
    },
    handleAiRepository() {
      if (this.loginUser.agencyId !== 0) return;
      //处理数据显示
      this.aiForm.qValue = this.questionInfo.qContent;
      this.aiForm.aValue = '';
      const commentList = this.questionInfo.comments.filter((m) => m.pId == 0);
      commentList.forEach((item) => {
        if (item.isCommentByTeach) {
          if (this.aiForm.aValue) this.aiForm.aValue += '\r\n';
          this.aiForm.aValue += item.commentContent;
        } else {
          this.aiForm.qValue += '\r\n' + item.commentContent;
        }
      });
      if (!this.aiForm.aValue) {
        this.aiForm.aValue = this.answerInfo.commentContent;
      }
      this.aiModelVisible = true;
    },
    addAiRepository() {
      this.aiModelVisible = false;
      study.addAiRepository(this.aiForm).then((res) => {
        if (res.status == 1) {
          this.$message.success('加入成功');
        }
      });
    },
        // 转人工 采用新增接口
    changeArtificial(item) {
      //提交数据
      study
        .saveUserQuestion({
          UserId: item.userId,
          ExerId: item.exerId,
          UmcId: item.umcId,
          PptId: item.pptId,
          FromPosition: item.fromPosition,
          QContent: item.qContent,
          souQid:item.qId,
          picfilename1: item.qPic1,
          picfilename2: item.qPic2,
          picfilename3: item.qPic3,
          teacherType:3,// 1为人工 2为AI 3为转人工
        })
        .then((res) => {
          if (res.status === 1) {
            this.$Message.success("已转人工老师，稍后解答");
            history.go(-1);
          } else {
            this.$Message.error(res.message);
          }
        });
    }
  },
  components: {
    PracticeItem,
    VideoPlayer,
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';
@import '../../assets/css/member-main.less';
@import '../../assets/css/question.less';

.go-back {
  color: #0e90d2;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  i {
    vertical-align: -0.2em;
    margin-right: 3px;
  }
}

.main-header {
  line-height: 60px;
  padding: 0 30px;
  color: #666;
  font-size: 16px;
}

.practice-item {
  width: 100%;
  padding: 15px 30px;
  background-color: #fff;
  border-top: none;
}

.question-list {
  margin-top: 1.6rem;
  background-color: #fff;
  padding: 20px 0;
  margin: 20px 40px;
  border: none;
  border-top: 1px dashed #ccc;
}

.question-ask {
  padding: 15px 0;
  border-bottom: 1px dashed #ccc;
}
.question-action {
  padding: 10px 0;
  font-size: 1.5rem;
  border-bottom: 1px dashed #ccc;
  .fr{
    font-size: 14px;
    color: #0e90d2;
  }
}

</style>
